import { pluralize } from '@travelata-libs/utils';
import { getSelectedCountry, getSelectedHotels, getSelectedResorts, isNone, type Selection } from '../model/selection';

const HOTEL_FORMS = ['отель', 'отеля', 'отелей'];

const RESORT_FORMS = ['курорт', 'курорта', 'курортов'];

export function buildLabel(selection: Selection): string {
  if (isNone(selection)) {
    return '';
  }

  const hotels = getSelectedHotels(selection);
  if (hotels.length > 0) {
    return hotels.length === 1 ? hotels[0].name : pluralize(HOTEL_FORMS, hotels.length, true);
  }

  const resorts = getSelectedResorts(selection);
  if (resorts.length > 0) {
    const country = getSelectedCountry(selection);
    const countryName = country?.name ?? '';
    const head = resorts.length === 1 ? resorts[0].name : pluralize(RESORT_FORMS, resorts.length, true);
    return countryName ? `${head}, ${countryName}` : head;
  }

  const country = getSelectedCountry(selection);
  return country?.name ?? '';
}
